import { KeyboardEvent } from 'react';

export const makeTabbable = (onClick: () => void) => ({
  onClick,
  tabIndex: 0,
  onKeyDown: ({ keyCode }: KeyboardEvent) => keyCode === 13 && onClick(),
});
